<template>
  <div class="all">
    <div
      class="width100 margin-auto backwhite"
      style="min-height: calc(100vh - 210px)"
    >
      <div class="width96 margin-auto backwhite bordert-bf pad-bot20">
        <p class="f18 textalign-center pad-top40 dimensional">
          {{ name }}
        </p>
        <p class="textalign-center pad-top20">
          <span class="f12 margin-left10 dimencont"
            >查看次数 : {{ view_count }} 发布时间 : {{ create_time }}</span
          >
        </p>
      </div>
      <div
        v-html="content"
        class="
          htmlcont
          pad-top20
          f14
          lineheight25
          width96
          margin-auto
          dimencont
        "
      ></div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
      <script>
import { articledetail } from "@/api/newhead/newhead.api";

export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      technologyid: "",
      name: "",
      view_count: "",
      create_time: "",
      content: "",
    };
  },

  components: {},
  methods: {},
  created() {
    this.technologyid = window.sessionStorage.getItem("technologyid");
    articledetail({ id: this.technologyid }).then((res) => {
      if (res.data.code == 200) {
        this.name = res.data.data.name;
        this.view_count = res.data.data.view_count;
        this.create_time = res.data.data.create_time;
        this.content = res.data.data.content;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
      <style scoped>
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>